import { useDomainStore } from '../../../stores/domainStore';

export default function DomainRegistryNotice() {
  const { registryError, registryLoading, retryRegistry } = useDomainStore();
  if (registryLoading) return <p role="status" className="p-3 text-sm text-base-content/60">Loading domains…</p>;
  if (!registryError) return null;
  return (
    <div role="alert" className="alert alert-error my-2 text-sm">
      <span>{registryError}</span>
      <button type="button" className="btn btn-sm" onClick={retryRegistry}>Try again</button>
    </div>
  );
}
